<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<h2 id="alert-dialog" class="alert-title" mat-dialog-title>
    <div>{{data.title}}</div>
    <div>{{data.titleRight}}</div>
</h2>
<mat-dialog-content id ="alert-contents" tabindex="-1" class="mat-typography">
    <div [innerHTML]="getUnsafeHTML()"></div>
    <p>{{data.content}}</p>
    <div *ngFor="let addContent of data.additionalContent">
    <p>{{addContent}}</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="button-wrapper">
    <button id="reject-button" *ngIf="data.showRejectBtn" mat-stroked-button [mat-dialog-close]="false">{{data.rejectBtnName}}</button>
    <button id="accept-button" mat-stroked-button [mat-dialog-close]="true">{{data.acceptBtnName}}</button>
</mat-dialog-actions>
